/**
 * Resolves a redirect target to an in-app path (pathname + search + hash),
 * or null if the value would leave the current origin.
 */
export function toInternalNavigationUrl(url: string): string | null {
  const trimmed = url?.trim();
  if (!trimmed) {
    return null;
  }

  try {
    const parsed = new URL(trimmed, `${window.location.origin}/`);
    if (parsed.origin !== window.location.origin) {
      return null;
    }
    if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
      return null;
    }
    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch {
    return null;
  }
}
